<app-standard-bottom-sheet [isOpen]="isSheetOpen()"
                           [preventOverlayClose]="true"
                           (overlayClick)="onOverlayDismiss()"
                           [isFullScreen]="true"
                           testId="bq9-not-complete-sheet">
  <app-section-header [title]="isAddNewItemMode ? 'Add New Item' : 'Not Complete'"
                      align="center"
                      testId="bq9-not-complete-header" />

  <div class="not-complete-content">
  <form [formGroup]="form"
        class="not-complete-form"
        data-testid="bq9-not-complete-form">

    <app-form-field label="Room"
                    inputId="not-complete-room"
                    [required]="true"
                    [control]="form.controls.lotAreaIdentifier"
                    [errorMessages]="{ required: 'Room is required.' }">
      <app-select-field inputId="not-complete-room"
                        formControlName="lotAreaIdentifier"
                        [options]="areas"
                        optionLabel="name"
                        optionValue="identifier"
                        placeholder="Select Room"
                        [invalid]="isInvalid('lotAreaIdentifier')"
                        testId="bq9-not-complete-room" />
    </app-form-field>

    <app-form-field label="Notes"
                    inputId="not-complete-notes"
                    [required]="true"
                    [control]="form.controls.text"
                    [maxLength]="maxNoteLength"
                    [errorMessages]="{ required: 'Notes are required.' }">
      <app-textarea inputId="not-complete-notes"
                    formControlName="text"
                    placeholder="Add notes"
                    [showCount]="false"
                    [maxLength]="maxNoteLength"
                    [invalid]="isInvalid('text')"
                    testId="bq9-not-complete-notes" />
    </app-form-field>

    <app-form-field [label]="'Photos (Max ' + maxPhotos + ')'"
                    [required]="true"
                    [control]="form.controls.photos"
                    [errorMessages]="{ required: 'A photo is required.' }">
      <app-photo-capture inputId="not-complete"
                         [images]="allImages()"
                         [invalid]="isInvalid('photos')"
                         [disabled]="imageCompressionPipelineService.isCompressingImages()"
                         [loading]="imageCompressionPipelineService.isLoadingImages()"
                         [optimizing]="imageCompressionPipelineService.isCompressingImages()"
                         [processingCount]="imageCompressionPipelineService.numberOfImagesBeingProcessed()"
                         (filesSelected)="onPhotosSelected($event)"
                         (imageClicked)="openImagesModal($event)"
                         testId="bq9-not-complete-photo" />
    </app-form-field>

    <app-form-field label="Vendor"
                    inputId="not-complete-vendor"
                    [optional]="true">
      <app-select-field inputId="not-complete-vendor"
                        formControlName="externalVendorId"
                        [filter]="true"
                        [options]="vendors"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Select Vendor"
                        [showClear]="true"
                        testId="bq9-not-complete-vendor-select">
        <ng-template #selectOptionItem
                     let-option
                     let-label="label">
          @if (option.id === selfAssignedVendorId) {
            <span class="bqa-pinned-select-option"
                  data-testid="bq9-not-complete-assign-to-me-option">{{ assignToMeLabel }}</span>
          } @else {
            {{ label }}
          }
        </ng-template>
      </app-select-field>
    </app-form-field>

    <app-form-field label="Issue Type"
                    inputId="not-complete-issue-type"
                    [required]="true"
                    [control]="form.controls.postCompleteStatus"
                    [errorMessages]="{ required: 'Please select an issue type.' }">
      <app-select-field inputId="not-complete-issue-type"
                        formControlName="postCompleteStatus"
                        [options]="issueTypeOptions"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select Issue Type"
                        [invalid]="isInvalid('postCompleteStatus')"
                        testId="bq9-not-complete-issue-type" />
    </app-form-field>

  </form>
</div>

@if (isAddNewItemMode) {
  <app-vertical-button-group [buttons]="footerButtons"
                               testId="bq9-not-complete-footer" />
} @else {
  <app-vertical-button-group [buttons]="footerButtons"
                             testId="bq9-not-complete-footer" />
}
</app-standard-bottom-sheet>